import AffirmationProgramService from 'src/modules/affirmationProgram/affirmationProgramService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';

const prefix = 'AFFIRMATIONPROGRAM_VIEW';

const affirmationProgramViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: affirmationProgramViewActions.FIND_STARTED,
      });

      const record = await AffirmationProgramService.find(id);

      dispatch({
        type: affirmationProgramViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: affirmationProgramViewActions.FIND_ERROR,
      });

      getHistory().push('/affirmation-program');
    }
  },
};

export default affirmationProgramViewActions;
